// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import BasicWarrantyEstimatorDealerCriteria from './basic-warranty-estimator-dealer-criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const BasicWarrantyEstimatorCriteria = props =>
    <div className='basic-warranty-estimator-criteria'>
        <div className='criteria-container'>
            <BasicWarrantyEstimatorDealerCriteria
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.selectedDealers}
            />
            <LabeledCriteria
                className='pin-criteria'
                isRequired={true}
                label='PIN'
                maxLength='17'
                onInputChange={props.onPinCriteriaChange}
                placeholder='PIN'
                type='text'
                value={props.pin}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

BasicWarrantyEstimatorCriteria.displayName = 'BasicWarrantyEstimatorCriteria';
BasicWarrantyEstimatorCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onPinCriteriaChange: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired

};

export default BasicWarrantyEstimatorCriteria;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/components/basic-warranty-estimator-report-criteria.js